import React from 'react'
import { NudistaMedium12, NudistaSemiBold11 } from '../Common/Fonts'
import { SearchInput } from '../Common/CommonStyle'
import { P } from '../Common/CommonStyle'
import styled from 'styled-components'
import {
  HomeNavWrapper,
  Icon,
  ViewSelectionButton,
  NudistaMedium7,
  NudistaSemiBold13,
  RobotoMedium14,
  NudistaBold14,
  SearchFlexDiv,
  SInput,
  RowFlexDiv,
  ColumnFlexDiv,
} from '../Common/CommonStyle'
import {
  NudistaMedium16,
  NudistaMedium11,
  NudistaSemiBold16,
  NudistaMedium9,
} from '../Common/Fonts'

const TopHeader = () => {
  return (
    <RowFlexDiv width='100%' justifyContent='space-between'>
      <RowFlexDiv width='74%'>
        <RowFlexDiv width='35%' gap='8px' justifyContent='flex-start'>
          <Icon
            width='13px'
            height='15px'
            src='/images/mainView/assignmentsView/assignment-detail.svg'
          ></Icon>
          <RowFlexDiv marginTop='1%' gap='5px'>
            <NudistaMedium16 color='secondary'>Assignments /</NudistaMedium16>{' '}
            <NudistaMedium16 color='primary'>NI283929123</NudistaMedium16>
          </RowFlexDiv>
        </RowFlexDiv>

        <RowFlexDiv width='35%'>
          <Button
            Imgsrc='/images/mainView/assignmentsView/gallery-view.svg'
            title='Gallery'
            Color='blue'
          />
          <Button
            Imgsrc='/images/mainView/assignmentsView/assignment.svg'
            title='Report'
            Color='white'
          />
        </RowFlexDiv>
        <RowFlexDiv gap='10px' width='21.5%' justifyContent='flex-end'>
          <Icon src='/images/mainView/assignmentsView/grid-view.svg' />
          <Icon src='/images/mainView/assignmentsView/list-view.svg' />
        </RowFlexDiv>
      </RowFlexDiv>

      <RowFlexDiv
        width='24.8%'
        gap='15px'
        opacity='0.7'
        justifyContent='flex-start'
      >
        <SearchFlexDiv
          width='90%'
          height='31px'
          borderRadius='4px'
          boxShadow='0 3px 6px 0 rgba(0, 0, 0, 0.16)'
        >
          <SInput
            height='70%'
            width='100%'
            icon='/images/navbar/magnifier.svg'
            placeholder={'Search in Assignment...'}
          />
        </SearchFlexDiv>
        <RowFlexDiv width='2%' justifyContent='flex-end'>
          <Icon
            // transform: ${({ rotate }) => (rotate ? '' : 'rotateY(180deg)')};

            transform='rotate(90deg)'
            src='/images/mainView/assignmentsView/dropdown.svg'
          />
        </RowFlexDiv>
      </RowFlexDiv>
    </RowFlexDiv>
  )
}

const Button = ({ Imgsrc, title, Color }) => {
  return (
    <RowFlexDiv
      width='50%'
      height='40px'
      gap='5px'
      justifyContent='center'
      outline='1px solid #6F03FD'
      backgroundColor={Color === 'blue' ? '#6A02FD' : '#FFFFFF'}
    >
      <Icon width='18px' height='18px' src={Imgsrc}></Icon>
      <NudistaMedium16
        color={Color === 'blue' ? 'whiteColor' : 'primary'}
        white
      >
        {title}
      </NudistaMedium16>{' '}
    </RowFlexDiv>
  )
}

export default TopHeader
